import { RU, BY, KZ, UZ } from '../../constants/countries';

import RUFieldsEN from './ru/DefaultFieldsEN';
import RUFieldsRU from './ru/DefaultFieldsRU';

import KZFieldsRU from './kz/DefaultFieldsRU';
import KZFieldsEN from './kz/DefaultFieldsEN';

import UZFieldsRU from './uz/DefaultFieldsRU';
import UZFieldsEN from './uz/DefaultFieldsEN';

import BYFieldsRU from './by/DefaultFieldsRU';
import BYFieldsEN from './by/DefaultFieldsEN';

export default {
    [RU]: {
        ru: RUFieldsRU,
        en: RUFieldsEN,
    },
    [KZ]: {
        ru: KZFieldsRU,
        en: KZFieldsEN,
    },
    [UZ]: {
        ru: UZFieldsRU,
        en: UZFieldsEN,
    },
    [BY]: {
        ru: BYFieldsRU,
        en: BYFieldsEN,
    },
}
